export default __webpack_public_path__ + "static/media/TC.2a24e06a.svg";